"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var clone = require("lodash/clone");

var vibrant_1 = require("./vibrant");

var Builder =
/** @class */
function () {
  function Builder(src, opts) {
    if (opts === void 0) {
      opts = {};
    }

    this._src = src;
    this._opts = opts;
    this._opts.filters = clone(vibrant_1.default.DefaultOpts.filters);
  }

  Builder.prototype.maxColorCount = function (n) {
    this._opts.colorCount = n;
    return this;
  };

  Builder.prototype.maxDimension = function (d) {
    this._opts.maxDimension = d;
    return this;
  };

  Builder.prototype.addFilter = function (f) {
    this._opts.filters.push(f);

    return this;
  };

  Builder.prototype.removeFilter = function (f) {
    var i = this._opts.filters.indexOf(f);

    if (i > 0) this._opts.filters.splice(i);
    return this;
  };

  Builder.prototype.clearFilters = function () {
    this._opts.filters = [];
    return this;
  };

  Builder.prototype.quality = function (q) {
    this._opts.quality = q;
    return this;
  };

  Builder.prototype.useImageClass = function (imageClass) {
    this._opts.ImageClass = imageClass;
    return this;
  };

  Builder.prototype.useGenerator = function (generator) {
    this._opts.generator = generator;
    return this;
  };

  Builder.prototype.useQuantizer = function (quantizer) {
    this._opts.quantizer = quantizer;
    return this;
  };

  Builder.prototype.build = function () {
    return new vibrant_1.default(this._src, this._opts);
  };

  Builder.prototype.getPalette = function (cb) {
    return this.build().getPalette(cb);
  };

  Builder.prototype.getSwatches = function (cb) {
    return this.build().getPalette(cb);
  };

  return Builder;
}();

exports.default = Builder;